import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import CollapsableCard from 'src/common/refactoredComponents/collapsableCard/CollapsableCard.jsx';

import {
    DetailsMainContainerBlock,
    MainContainerItems,
    Title,
    Subtitle,
    DisplayCard,
    ContainerItems,
    Header,
    Value,
    ItemContainer,
} from './ReplenRequest.styled';
import { OrderDetailTitle } from 'src/pages/orders/components/orderDetails/OrderDetails.styled';
import { capitalizeText, setItemsDataHandler } from 'src/utils/util';
import { sizes } from 'src/styles/Media.styled';
import {
    OrderDetailFooterContainer,
    InvoiceCreatedDetail,
    WrapperContainer,
} from 'src/pages/orders/components/orderDetails/shipAndTrack/ShipAndTrack.styled';
import { useTranslation } from 'react-i18next';
import { getDisplayDate, getDisplayDateTime } from 'src/utils/dateUtils';
import { convertTime24To12, logErrorToConsole } from 'src/utils/util';
import { COUNTRY_CODE_JAPN } from 'src/constants/productConstants';
import { loginReducer } from 'src/common/redux/reducers/userDetails';
import { VISIBLE } from 'src/constants/appConstants';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const ReplenRequest = ({ handleSetItemClick, ordersList }) => {
    const [expandedCard, setExpandedCard] = useState(true);

    const { replenishmentRequests } = useSelector(
        (state) => state.orderSummaryReducer
    );
    const countryCode = localStorage.getItem('countryISOCode');

    const toggleCard = () => {
        setExpandedCard(!expandedCard);
    };
    const usageReplenishmentSurgeryDateVisibility = useSelector(
        (state) => state.loginReducer.usageReplenishmentSurgeryDateVisibility
    );
    const repleneCount =
        replenishmentRequests && replenishmentRequests?.length
            ? replenishmentRequests.length
            : 0;

    const setItemHandler = (data, orderList) => {
        const setItemDetails = setItemsDataHandler(data, orderList);
        handleSetItemClick(setItemDetails);
    };

    const winWidth = window.innerWidth;

    const [modifyDate, setModifyDate] = useState('');
    const [modifyTime, setModifyTime] = useState('');
    const { t } = useTranslation();

    const isCondensedView = useSelector(
        (state) => state.loginReducer.isCondensedView
    );
    
    const { isLanguageChanged } = useSelector((state) => ({
        isLanguageChanged: state.loginReducer.isLanguageChanged,
    }));
    const { orderBasicDetails, lastModifiedBy, lastModifiedDate } = useSelector(
        (state) => ({
            orderBasicDetails: state.orderSummaryReducer.orderBasicDetails,
            lastModifiedBy:
                state.orderSummaryReducer.orderBasicDetails?.orderSummaryDetail
                    ?.lastModifiedBy,
            lastModifiedDate:
                state.orderSummaryReducer.orderBasicDetails?.orderSummaryDetail
                    ?.lastModifiedDate,
        })
    );
    const transferRecipientAddress = useSelector(
        (state) =>
            state.orderSummaryReducer.orderBasicDetails?.transferRecipients?.[0]
                .transferRecipientAddress
    );
    const isTransferRecipients =
        transferRecipientAddress &&
        Object.keys(transferRecipientAddress).length !== 0;

    useEffectWithErrorLogging(() => {
        if (lastModifiedDate && lastModifiedDate !== '') {
            setModifyDate(getDisplayDate(new Date(lastModifiedDate)));
            setModifyTime(convertTime24To12(new Date(lastModifiedDate)));
        }
    }, [lastModifiedDate]);

    return (
        <>
            <OrderDetailTitle mbMargin={isCondensedView && '10px 0px 20px 14px'}>
                {t('reportUsage.replen.replenHeader.replenishmentRequest')}
            </OrderDetailTitle>
            <CollapsableCard
                id="orders-replenRequest-replenRequest-itemsToReplenish"
                title={`${t('replen.ItemstoReplenish')} (${repleneCount})`}
                onClick={toggleCard}
                isExpanded={expandedCard}
                padding={'15px 16px'}
                mbHeaderMargin={'0 0 16px 0'}
                isConsignment={orderBasicDetails?.currentOrderType === 'KE'}
            >
                {expandedCard &&
                replenishmentRequests &&
                replenishmentRequests?.length > 0 ? (
                    <>
                        {replenishmentRequests?.map((data, index) => {
                            return (
                                <DisplayCard key={data?.cfn ? data.cfn : index}>
                                    <DetailsMainContainerBlock>
                                        <MainContainerItems
                                            marginBottom={
                                                orderBasicDetails?.currentOrderType ===
                                                'KE'
                                                    ? winWidth <=
                                                      sizes.mobileDevice
                                                        ? '16px'
                                                        : '10px'
                                                    : '16px'
                                            }
                                        >
                                            {data?.cfn ? (
                                                <Title
                                                 id={`orders-replenrequest-item-${index}-cfn-title`}
                                                    onClick={() => {
                                                        try {
                                                        setItemHandler(
                                                            data,
                                                            ordersList
                                                        );
                                                        } catch (error) {
                                                            logErrorToConsole(error);
                                                        }
                                                    }}
                                                >
                                                    {' '}
                                                    {data?.cfn
                                                        ? data.cfn
                                                        : null}
                                                </Title>
                                            ) : (
                                                <Title></Title>
                                            )}

                                            <Subtitle
                                                width="60%"
                                                mbWidth={'100%'}
                                            >
                                                {data?.description
                                                    ? capitalizeText(
                                                          data.description
                                                      )
                                                    : null}
                                            </Subtitle>
                                        </MainContainerItems>
                                        <ContainerItems marginBottom={'16px'}>
                                            <ItemContainer>
                                                <Header color={'#202124'}>
                                                    {orderBasicDetails?.currentOrderType ===
                                                        'KE' &&
                                                    winWidth <=
                                                        sizes.mobileDevice
                                                        ? t(
                                                              'reportUsage.summary.quantity'
                                                          )
                                                        : t(
                                                              'orders.orderDetails.replenRequest.ordered'
                                                          )}
                                                </Header>
                                                <Value>
                                                    {' '}
                                                    {data?.quantity
                                                        ? data.quantity
                                                        : 0}
                                                </Value>
                                            </ItemContainer>
                                            <ItemContainer>
                                                <Header color={'#202124'}>
                                                    {t(
                                                        'orders.orderDetails.replenRequest.shipped'
                                                    )}
                                                </Header>
                                                <Value>
                                                    {' '}
                                                    {data?.shippedCount
                                                        ? data.shippedCount
                                                        : 0}
                                                </Value>
                                            </ItemContainer>
                                            <ItemContainer>
                                                <>
                                                    <Header
                                                        color={
                                                            data?.backOrderCount &&
                                                            data.backOrderCount >
                                                                0
                                                                ? '#ED002A'
                                                                : '#202124'
                                                        }
                                                    >
                                                        {t(
                                                            'orders.orderDetails.replenRequest.backOrder'
                                                        )}
                                                    </Header>
                                                    <Value
                                                        color={
                                                            data?.backOrderCount &&
                                                            data.backOrderCount >
                                                                0
                                                                ? '#ED002A'
                                                                : '#000000'
                                                        }
                                                    >
                                                        {data?.backOrderCount
                                                            ? data.backOrderCount
                                                            : 0}
                                                    </Value>
                                                </>
                                            </ItemContainer>
                                        </ContainerItems>
                                        {data?.shippingAddress ? (
                                            <MainContainerItems
                                                marginBottom={'16px'}
                                                // width={
                                                //     countryCode ===
                                                //         COUNTRY_CODE_JAPN &&
                                                //     window.innerWidth >=
                                                //         sizes.mobileDevice &&
                                                //     data?.requestedDeliveryDate
                                                //         ? '60%'
                                                //         : ''
                                                // }
                                            >
                                                <>
                                                    <Title
                                                        color={'#202124'}
                                                        fontSize={'14px'}
                                                    >
                                                        {t(
                                                            'orders.orderDetails.replenRequest.shippingAddress'
                                                        )}
                                                    </Title>
                                                    {data?.attentionLine ? (
                                                        <Subtitle
                                                            className="orders-replen-request-attention-dt-mask"
                                                            fontSize={'15px'}
                                                        >
                                                            {/*{data.attn} */}
                                                            {t(
                                                                'reportUsage.replen.replenListView.attn'
                                                            )}{' '}
                                                            {data.attentionLine}
                                                        </Subtitle>
                                                    ) : null}
                                                    {data?.shippingAddress
                                                        ?.line1 ? (
                                                        <Subtitle
                                                            className="orders-replen-request-address-line-dt-mask"
                                                            fontSize={'15px'}
                                                        >
                                                            {
                                                                data
                                                                    .shippingAddress
                                                                    .line1
                                                            }
                                                        </Subtitle>
                                                    ) : null}

                                                    {data?.shippingAddress
                                                        ?.city ||
                                                    data?.shippingAddress
                                                        ?.country ||
                                                    data?.shippingAddress
                                                        ?.state ||
                                                    data?.shippingAddress
                                                        ?.postalCode ? (
                                                        <>
                                                            <Subtitle
                                                                className="orders-replen-request-city-state-postal-dt-mask"
                                                                style={{
                                                                    lineHeight:
                                                                        '20px',
                                                                }}
                                                                mbWidth={
                                                                    orderBasicDetails?.currentOrderType ===
                                                                    'KE'
                                                                        ? '70%'
                                                                        : '100%'
                                                                }
                                                                fontSize={
                                                                    '15px'
                                                                }
                                                            >
                                                                {data
                                                                    ?.shippingAddress
                                                                    ?.country
                                                                    ? data
                                                                          .shippingAddress
                                                                          .country
                                                                    : null}
                                                                {','} <br />
                                                                {data
                                                                    ?.shippingAddress
                                                                    ?.city
                                                                    ? data
                                                                          .shippingAddress
                                                                          .city
                                                                    : null}
                                                                {','}{' '}
                                                                {data
                                                                    ?.shippingAddress
                                                                    ?.state
                                                                    ? data
                                                                          .shippingAddress
                                                                          .state
                                                                    : null}{' '}
                                                                <br />
                                                                {data
                                                                    ?.shippingAddress
                                                                    ?.postalCode
                                                                    ? data
                                                                          .shippingAddress
                                                                          .postalCode
                                                                    : null}
                                                            </Subtitle>
                                                        </>
                                                    ) : null}
                                                    {data?.transferRecipient
                                                        ?.careOfField ? (
                                                        <Subtitle
                                                            className="orders-replen-request-care-of-dt-mask"
                                                            fontSize={'15px'}
                                                        >
                                                            {/*{data.attn} */}
                                                            {t(
                                                                'consignmentBilling.replen.selectShipToAddress.careOf'
                                                            )}
                                                            {':'}{' '}
                                                            {
                                                                data
                                                                    .transferRecipient
                                                                    .careOfField
                                                            }
                                                        </Subtitle>
                                                    ) : null}
                                                </>
                                            </MainContainerItems>
                                        ) : null}
                                        {isTransferRecipients ? (
                                            <MainContainerItems
                                                marginBottom={'16px'}
                                            >
                                                <>
                                                    <Title
                                                        color={'#202124'}
                                                        fontSize={'14px'}
                                                    >
                                                        {t(
                                                            'reportUsage.replen.selectShipToAddress.transferRecipient'
                                                        )}
                                                    </Title>
                                                    {data?.transferRecipient
                                                        ?.shipToAccount ? (
                                                        <Subtitle
                                                            className="orders-replen-request-recipient-dt-mask"
                                                            fontSize={'15px'}
                                                        >
                                                            {
                                                                data
                                                                    .transferRecipient
                                                                    .shipToAccount
                                                            }
                                                        </Subtitle>
                                                    ) : null}

                                                    {data?.transferRecipient
                                                        ?.transferRecipientAddress
                                                        ?.city ||
                                                    data?.transferRecipient
                                                        ?.transferRecipientAddress
                                                        ?.line1 ||
                                                    data?.transferRecipient
                                                        ?.transferRecipientAddress
                                                        ?.state ||
                                                    data?.transferRecipient
                                                        ?.transferRecipientAddress
                                                        ?.stateName ||
                                                    data?.transferRecipient
                                                        ?.transferRecipientAddress
                                                        ?.postalCode ? (
                                                        <>
                                                            <Subtitle
                                                                className="orders-replen-request-recipient-address-dt-mask"
                                                                style={{
                                                                    lineHeight:
                                                                        '20px',
                                                                }}
                                                                mbWidth={
                                                                    orderBasicDetails?.currentOrderType ===
                                                                    'KE'
                                                                        ? '70%'
                                                                        : '100%'
                                                                }
                                                                fontSize={
                                                                    '15px'
                                                                }
                                                            >
                                                                {data
                                                                    ?.transferRecipient
                                                                    ?.transferRecipientAddress
                                                                    ?.line1
                                                                    ? data
                                                                          .transferRecipient
                                                                          ?.transferRecipientAddress
                                                                          .line1
                                                                    : null}
                                                                {','} <br />
                                                                {data
                                                                    ?.transferRecipient
                                                                    ?.transferRecipientAddress
                                                                    ?.city
                                                                    ? data
                                                                          .transferRecipient
                                                                          ?.transferRecipientAddress
                                                                          .city
                                                                    : null}
                                                                {','}{' '}
                                                                {data
                                                                    ?.transferRecipient
                                                                    ?.transferRecipientAddress
                                                                    ?.country
                                                                    ? data
                                                                          .transferRecipient
                                                                          ?.transferRecipientAddress
                                                                          .country
                                                                    : null}{' '}
                                                                {data
                                                                    ?.transferRecipient
                                                                    ?.transferRecipientAddress
                                                                    ?.stateName
                                                                    ? data
                                                                          .transferRecipient
                                                                          ?.transferRecipientAddress
                                                                          .stateName
                                                                    : null}
                                                                {','}{' '}
                                                                {data
                                                                    ?.transferRecipient
                                                                    ?.transferRecipientAddress
                                                                    ?.state
                                                                    ? data
                                                                          .transferRecipient
                                                                          ?.transferRecipientAddress
                                                                          .state
                                                                    : null}
                                                                <br />
                                                                {data
                                                                    ?.transferRecipient
                                                                    ?.transferRecipientAddress
                                                                    ?.postalCode
                                                                    ? data
                                                                          .transferRecipient
                                                                          ?.transferRecipientAddress
                                                                          .postalCode
                                                                    : null}
                                                            </Subtitle>
                                                        </>
                                                    ) : null}
                                                </>
                                            </MainContainerItems>
                                        ) : null}
                                        {/* {data?.trackingNoAndUrl ? (
                                            <MainContainerItems
                                                marginBottom={'16px'}
                                            >
                                                {data?.trackingNoAndUrl
                                                    ?.entry ? (
                                                    <TrackingNumberLabel
                                                        trackingDetails={
                                                            data
                                                                .trackingNoAndUrl
                                                                .entry
                                                        }
                                                    />
                                                ) : (
                                                    <MainContainerItems
                                                        marginBottom={'16px'}
                                                    >
                                                        <TrackingNumberLabel
                                                            isTrackingNumberNotAvailable={
                                                                true
                                                            }
                                                        />
                                                    </MainContainerItems>
                                                )}
                                            </MainContainerItems>
                                        ) : (
                                            <MainContainerItems
                                                marginBottom={'16px'}
                                            >
                                                <TrackingNumberLabel
                                                    isTrackingNumberNotAvailable={
                                                        true
                                                    }
                                                />
                                            </MainContainerItems>
                                        )} */}

                                        {data?.methodName ||
                                        data?.requestedDeliveryDate ||
                                        data?.surgeryDate ? (
                                            <MainContainerItems
                                                marginBottom={'16px'}
                                                // width={
                                                //     // data?.requestDeliveryDate &&
                                                //     countryCode ===
                                                //         COUNTRY_CODE_JAPN &&
                                                //     window.innerWidth >=
                                                //         sizes.mobileDevice &&
                                                //     data?.requestedDeliveryDate &&
                                                //     data?.surgeryNumber
                                                //         ? '25%'
                                                //         : ''
                                                // }
                                            >
                                                {data?.methodName && (
                                                    <>
                                                        <Title
                                                            color={'#202124'}
                                                            fontSize={'14px'}
                                                        >
                                                            {t(
                                                                'orders.orderDetails.replenRequest.shippingMethod'
                                                            )}
                                                        </Title>
                                                        <Subtitle
                                                            className="orders-replen-request-shipping-method-dt-mask"
                                                            mbWidth={'100%'}
                                                            fontSize={'15px'}
                                                            marginBottom={
                                                                '16px'
                                                            }
                                                        >
                                                            {data.methodName}
                                                        </Subtitle>
                                                    </>
                                                )}
                                                {data?.surgeryDate &&
                                                    usageReplenishmentSurgeryDateVisibility ===
                                                        VISIBLE && (
                                                        <>
                                                            <Title
                                                                color={
                                                                    '#202124'
                                                                }
                                                                fontSize={
                                                                    '14px'
                                                                }
                                                            >
                                                                {t(
                                                                    'common.surgeryDateLabel'
                                                                )}
                                                            </Title>
                                                            <Subtitle
                                                                mbWidth={'100%'}
                                                                fontSize={
                                                                    '15px'
                                                                }
                                                            >
                                                                {data?.surgeryDate
                                                                    ? getDisplayDate(
                                                                          data?.surgeryDate
                                                                      )
                                                                    : ''}
                                                            </Subtitle>
                                                        </>
                                                    )}
                                                {data?.requestedDeliveryDate && (
                                                    <>
                                                        <Title
                                                            color={'#202124'}
                                                            fontSize={'14px'}
                                                        >
                                                            {t(
                                                                'common.requestedDeliveryDateLabel'
                                                            )}
                                                        </Title>
                                                        <Subtitle
                                                            mbWidth={'100%'}
                                                            fontSize={'15px'}
                                                        >
                                                            {data?.requestedDeliveryDate
                                                                ? getDisplayDate(
                                                                      data?.requestedDeliveryDate
                                                                      //     .replace(
                                                                      //       /\d{2}:\d{2}:\d{2}/,
                                                                      //       '00:00:00'
                                                                      //   )
                                                                      //not sure, sometime we will get time and sometime not.
                                                                  )
                                                                : ''}
                                                        </Subtitle>
                                                    </>
                                                )}
                                            </MainContainerItems>
                                        ) : null}
                                        {data?.surgeryNumber ? (
                                            <MainContainerItems
                                                marginBottom={'16px'}
                                                // width={
                                                //     // data?.requestDeliveryDate &&
                                                //     countryCode ===
                                                //         COUNTRY_CODE_JAPN &&
                                                //     window.innerWidth >=
                                                //         sizes.mobileDevice &&
                                                //     data?.surgeryNumber
                                                //         ? '20%'
                                                //         : ''
                                                // }
                                            >
                                                <Title
                                                    color={'#202124'}
                                                    fontSize={'14px'}
                                                >
                                                    {t(
                                                        'common.surgeryNumberLabel'
                                                    )}
                                                </Title>
                                                <Subtitle
                                                    mbWidth={'100%'}
                                                    fontSize={'15px'}
                                                    // marginLeft={
                                                    //     window.innerWidth >=
                                                    //     sizes.mobileDevice
                                                    //         ? '63px'
                                                    //         : ''
                                                    // }
                                                >
                                                    {data.surgeryNumber}
                                                </Subtitle>
                                            </MainContainerItems>
                                        ) : null}
                                    </DetailsMainContainerBlock>
                                </DisplayCard>
                            );
                        })}
                    </>
                ) : null}
            </CollapsableCard>

            {orderBasicDetails?.currentOrderType === 'KE' &&
            winWidth <= sizes.mobileDevice ? (
                <OrderDetailFooterContainer>
                    {lastModifiedBy || modifyDate || modifyTime ? (
                        <>
                            <InvoiceCreatedDetail margin={'0 3px 0 0'}>
                                {isLanguageChanged && lastModifiedBy
                                    ? ''
                                    : t('orders.orderSummaryTabs.lastmodify')}
                            </InvoiceCreatedDetail>
                            {lastModifiedBy ? (
                                <>
                                    <InvoiceCreatedDetail margin={'0 3px 0 0'}>
                                        {isLanguageChanged
                                            ? t(
                                                  'orders.orderSummaryTabs.lastmodify'
                                              )
                                            : t(
                                                  'orders.orderDetails.billingSummary.by'
                                              )}
                                    </InvoiceCreatedDetail>
                                    <InvoiceCreatedDetail
                                        margin={'0 2px 0 0'}
                                        isCreatedDateBy
                                    >
                                        {lastModifiedBy}
                                    </InvoiceCreatedDetail>
                                </>
                            ) : null}
                            <WrapperContainer>
                                {modifyDate ? (
                                    <InvoiceCreatedDetail
                                        margin={'0 2px 0 -1px'}
                                    >
                                        {modifyDate}
                                    </InvoiceCreatedDetail>
                                ) : null}
                                {modifyTime ? (
                                    <InvoiceCreatedDetail>
                                        {modifyTime} {' ' + 'IST'}
                                    </InvoiceCreatedDetail>
                                ) : null}
                            </WrapperContainer>
                        </>
                    ) : null}
                </OrderDetailFooterContainer>
            ) : null}
        </>
    );
};

export default ReplenRequest;
